import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EditCustomerFormValues } from "../schema/edit-customer.schema";
import { editCustomer } from "src/redux/api/_customer.api";
import { toast } from "react-toastify";
import { customerKeys } from "./useFetchCustomers";

export const useEditCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      values,
    }: {
      id: number;
      values: Partial<EditCustomerFormValues>;
    }) => editCustomer(id, values),

    onSuccess: () => {
      
      queryClient.invalidateQueries({ queryKey: customerKeys.all });

      toast.success("Customer Updated Successfully!");
    },

    onError: () => {
      toast.error("Failed to update customer details!");
    },
  });
};
